import styled, { css, StyledComponent } from "styled-components";
import { StyledAttrsProps } from "../../../services/styled.css";
import { transSizeToRem, getCellWidthByGridM } from "../../../utils/size";

export const ProductWrap = styled.section`
	position: relative;
`;

export const Grid = styled.section.attrs((props: StyledAttrsProps) => ({
	type: "text",
	size: props.size ? 5 : undefined,
}))`
	display: flex;
	flex-wrap: wrap;
`;
export interface ProductSkeletonBaseProps {
	gridWidth?: string;
	gridCol?: number;
	gridGap?: number;
	parentGap?: number;
}
export const ProductSkeletonBase = styled.section`
	display: grid;
	grid-template-areas: ".";
	flex-wrap: wrap;
	width: 100%;
	box-sizing: border-box;

	${(props: ProductSkeletonBaseProps) => {
		const gap = transSizeToRem(props.gridGap || 0.5);
		const parentGap = transSizeToRem(props.parentGap || 0.5);

		return css`
			grid-gap: ${gap};
			padding: 0 ${parentGap} ${parentGap} ${parentGap};
		`;
	}}

	${(props: ProductSkeletonBaseProps) => {
		const { gridCol = 2, gridGap = 0.5, parentGap = 0.5 } = props;
		const width = getCellWidthByGridM({
			gridCol,
			gridGap,
			contentWidth: `100vw - ${parentGap * 2}rem`,
		});
		return css`
			grid-template-columns: repeat(${gridCol}, ${width});
		`;
	}}

	@supports not (display: grid) {
		display: flex;
		grid-gap: 0;
		${(props: ProductSkeletonBaseProps) => {
			const gridCol = props.gridCol || 2;
			const gap = transSizeToRem(props.gridGap || 0.5);
			return css`
				margin-right: ${gap};
				&:nth-child(${gridCol}n + 1),
				&:first-child {
					margin-right: 0;
				}
			`;
		}}
	}
`;

export const ProductSkeletonContainer = styled(ProductSkeletonBase)`
	overflow: hidden;
`;

export const RollOverBox: StyledComponent<"section", any> = styled.section`
	width: 100%;
	padding: 0 0 0.75rem 0;
`;
export const RollOverContainer = styled(ProductSkeletonBase)`
	overflow-x: scroll;
	flex-wrap: nowrap;
	grid-template-columns: repeat(3, minmax(9.375rem, 100%));
	grid-auto-flow: column dense;
	overflow-x: scroll;
	min-height: 7.5rem;
	height: auto;
	padding: 0 0.5rem;
	box-sizing: border-box;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const ProductCardWrap = styled.section`
	> a {
		width: 100%;
		height: 100%;
	}
`;
